export default {
  tags: {
    preferred: 'Suositeltu',
  },
};
